import { render } from "./Examine.vue?vue&type=template&id=3c5fe7e6&scoped=true"
import script from "./Examine.vue?vue&type=script&lang=js"
export * from "./Examine.vue?vue&type=script&lang=js"

import "./Examine.vue?vue&type=style&index=0&id=3c5fe7e6&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5fe7e6"]])

export default __exports__